<template>
  <!-- <div> -->
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="600px">
      <template v-slot:activator="{ on }">
        <!-- <v-btn
          @click.stop="dialog = true"
          large
          text
          outlined
          rounded
          class="ma-3"
          color="green"
          style="background-color: black"
        >EDIT PLAINTIFF</v-btn>-->
        <v-btn @click.stop="openDialog" text rounded large>EDIT</v-btn>
      </template>
      <v-card
        class="ma-auto pa-2"
        flat
        filled
        style="
          border-radius: 26px;
          border: 1px solid #18CAE6;
          max-width: 600px;
          
        "
      >
        <v-card-title>
          <span class="headline">EDIT</span
          ><span class="red--text"> PLAINTIFF</span>
        </v-card-title>
        <v-form class="ma-2 pa-2" @submit.prevent="onEditPlaintiff" ref="form">
          <div>
            <v-card
              style="max-width: 500px"
              outlined
              tile
              rounded
              class="ma-auto"
              dense
            >
              <!-- <v-text-field
                label="PLAINTIFF FULL NAME"
                name="name"
                validate-on-blur
                required
                id="name"
                class="ma-2"
                outlined
                v-model="fullName"
                autofocus
                clearable
                color="#a07800"
              ></v-text-field>-->
              <v-radio-group v-model="type" row>
                <v-radio label="Individual" value="individual"></v-radio>
                <v-radio label="Business" value="business"></v-radio>
                <v-radio label="Government" value="government"></v-radio>
              </v-radio-group>
              <v-text-field
                label="PLAINTIFF FULL BUSINESS NAME"
                v-if="type == 'business'"
                name="name"
                validate-on-blur
                required
                id="name"
                class="ma-2"
                outlined
                v-model="bizName"
                autofocus
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <v-text-field
                label="FULL GOVERNMENT ENTITY NAME"
                v-if="type == 'government'"
                name="name"
                validate-on-blur
                required
                id="name"
                class="ma-2"
                outlined
                v-model="bizName"
                autofocus
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <div v-if="type == 'individual'">
                <v-text-field
                  label="PLAINTIFF FIRST NAME"
                  name="name"
                  validate-on-blur
                  required
                  id="name"
                  class="ma-2"
                  outlined
                  v-model="firstName"
                  autofocus
                  clearable
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>

                <v-text-field
                  label="PLAINTIFF LAST NAME"
                  name="name"
                  validate-on-blur
                  required
                  id="name"
                  class="ma-2"
                  outlined
                  v-model="lastName"
                  clearable
                  color="#2E5473"
                  dense
                  filled
                ></v-text-field>
              </div>

              <v-text-field
                label="STREET ADDRESS"
                name="addressline1"
                id="adressline1"
                class="ma-2"
                outlined
                v-model="addressLine1"
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <v-text-field
                label="CITY, STATE &amp; ZIP"
                name="cityStateZip"
                id="cityStateZip"
                class="ma-2"
                outlined
                v-model="cityStateZip"
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>

              <div v-if="type !== 'business' && type !== 'government'">
                <v-text-field
                  v-model="dateOfBirth"
                  label="DATE OF BIRTH"
                  name="dateOfBirth"
                  validate-on-blur
                  required
                  id="dateOfBirth"
                  class="ma-2"
                  outlined
                  clearable
                  color="#2E5473"
                  dense
                  filled
                  v-mask="dateMask"
                  hint="MM/DD/YYYY"
                  persistent-hint
                ></v-text-field>
              </div>

              <v-text-field
                label="PLAINTIFF PHONE"
                name="phone"
                validate-on-blur
                required
                id="phone"
                class="ma-2"
                outlined
                v-model="phone"
                v-mask="mask"
                clearable
                type="tel"
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <v-text-field
                label="EMAIL"
                name="email"
                validate-on-blur
                required
                id="email"
                class="ma-2"
                outlined
                v-model="email"
                clearable
                :rules="[rules.email]"
                type="email"
                color="#2E5473"
                dense
                filled
              ></v-text-field>
              <!-- ATTORNEY NAME  -->
              <v-text-field
                label="ATTORNEY NAME "
                name="attorney"
                required
                id="attorney"
                class="ma-2"
                outlined
                v-model="attorney"
                clearable
                color="#2E5473"
                dense
                filled
              ></v-text-field>
            </v-card>
          </div>
          <v-layout row class="mt-2">
            <v-spacer></v-spacer>
            <v-btn rounded text outlined @click="cancelDialog">CANCEL</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              rounded
              color="black"
              :disabled="!formIsValid"
              dark
              type="submit"
              >SUBMIT</v-btn
            >
            <v-spacer></v-spacer>
            <!-- <v-btn @click="logFullName"></v-btn> -->
          </v-layout>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
/**
 *
 *
 * this component may need to be edited to mach the newest version of CreatePlaintiff component
 *
 *
 */

import { mask } from "vue-the-mask";
// import slugify from "slugify";
import * as firebase from "firebase";

export default {
  props: ["plaintiff", "user", "matter"],
  // props: ["user", "matter"],
  directives: {
    mask
  },
  data() {
    return {
      menu: false,
      dialog: false,
      // allowSave: false,
      mask: "(###) ###-####",
      dateMask: "##/##/####",
      // fullName: this.matter.fullName,
      bizName: this.plaintiff.fullName,
      firstName: this.plaintiff.firstName,
      lastName: this.plaintiff.lastName,
      addressLine1: this.plaintiff.addressLine1,
      cityStateZip: this.plaintiff.cityStateZip,
      phone: this.plaintiff.phone,
      email: this.plaintiff.email,
      attorney: this.plaintiff.attorney,
      dateOfBirth: this.plaintiff.dateOfBirth,
      type: this.plaintiff.type,
      rules: {
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Invalid e-mail.";
        }
      }
    };
  },
  computed: {
    formIsValid() {
      return this.fullName !== null && this.phone !== null;
    },
    fullName() {
      if (this.plaintiff.type == "individual") {
        return this.plaintiff.firstName + " " + this.plaintiff.lastName;
      } else if (this.type == "business" || this.type == "government") {
        return this.plaintiff.fullName;
      } else {
        return null;
      }
    }
    // plaintiff() {
    //   return this.$store.getters.plaintiff;
    // }
  },
  watch: {
    menu(val) {
      val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"));
    }
  },
  methods: {
    // logFullName() {
    //   console.log("fullName", this.fullName);
    // },
    openDialog() {
      this.dialog = true;
      console.log(this.plaintiff);
      this.firstName = this.plaintiff.firstName;
      this.lastName = this.plaintiff.lastName;
      this.addressLine1 = this.plaintiff.addressLine1;
      this.cityStateZip = this.plaintiff.cityStateZip;
      this.phone = this.plaintiff.phone;
      this.email = this.plaintiff.email;
      this.attorney = this.plaintiff.attorney;
      this.dateOfBirth = this.plaintiff.dateOfBirth;
      this.type = this.plaintiff.type;
    },
    cancelDialog() {
      this.menu = false;
      this.dialog = false;
      this.allowSave = false;
      this.bizName = null;
      // this.fullName = null;
      this.firstName = this.plaintiff.firstName;
      this.lastName = this.plaintiff.lastName;
      this.addressLine1 = this.plaintiff.addressLine1;
      this.cityStateZip = this.plaintiff.cityStateZip;
      this.phone = this.plaintiff.phone;
      this.email = this.plaintiff.email;
      this.attorney = this.plaintiff.attorney;
      this.dateOfBirth = this.plaintiff.dateOfBirth;
      this.type = this.plaintiff.type;
    },
    onEditPlaintiff() {
      //////////////experimenting
      // let alias = this.fullName.trim() + " " + this.phone;
      // let partySlug = slugify(alias, {
      //   replacement: "-",
      //   remove: /[$*_+~.()'"!\-:@,]/g,
      //   lower: true
      // });
      let formSent = false;
      let editedPlaintiff;
      if (this.plaintiff.formSent) {
        formSent = true;
        editedPlaintiff = {
          firstName: this.firstName,
          lastName: this.lastName,
          fullName: this.fullName,
          addressLine1: this.addressLine1,
          cityStateZip: this.cityStateZip,
          phone: this.phone,
          email: this.email,
          attorney: this.attorney,
          dateOfBirth: this.dateOfBirth,
          type: this.type,
          partySlug: this.plaintiff.partySlug,
          formSent
        };
      } else if (this.plaintiff.formList) {
        editedPlaintiff = {
          firstName: this.firstName,
          lastName: this.lastName,
          fullName: this.fullName,
          addressLine1: this.addressLine1,
          cityStateZip: this.cityStateZip,
          phone: this.phone,
          email: this.email,
          attorney: this.attorney,
          dateOfBirth: this.dateOfBirth,
          type: this.type,
          partySlug: this.plaintiff.partySlug,
          formList: this.plaintiff.formList
        };
      }

      let oldPlaintiff = this.plaintiff;
      console.log("oldPlaintiff to be removed", oldPlaintiff);
      console.log("editedPlaintiff to be added", editedPlaintiff);

      firebase
        .firestore()
        // .collection("firms")
        // .doc(this.user.firmSlug)
        .collection("matters")
        .doc(this.matter.matterSlug)
        .update({
          plaintiffs: firebase.firestore.FieldValue.arrayRemove(oldPlaintiff)
        })
        .then(() => {
          console.log("delete success");
          firebase
            .firestore()
            // .collection("firms")
            // .doc(this.user.firmSlug)
            .collection("matters")
            .doc(this.matter.matterSlug)
            .update({
              plaintiffs: firebase.firestore.FieldValue.arrayUnion(
                editedPlaintiff
              )
            })
            .then(() => {
              console.log("update success");
              firebase
                .firestore()
                // .collection("firms")
                // .doc(this.user.firmSlug)
                .collection("matters")
                .doc(this.matter.matterSlug)
                .collection("clients")
                .doc(oldPlaintiff.partySlug)
                .update({
                  firstName: editedPlaintiff.firstName,
                  lastName: editedPlaintiff.lastName,
                  fullName: editedPlaintiff.fullName,
                  // clientSlug: this.partySlug,
                  username: editedPlaintiff.email,
                  partyType: editedPlaintiff.type,
                  password: editedPlaintiff.phone,
                  phone: editedPlaintiff.phone
                  // "formDef.link": ``
                })
                .then(() => {
                  return console.log(
                    "successfully edited client in client collection"
                  );
                })
                .catch(err => {
                  return err;
                });
              // if (client && client.)
              const editClientRole = firebase
                .functions()
                .httpsCallable("editClientRole");
              editClientRole({
                email: editedPlaintiff.email,
                password: editedPlaintiff.phone,
                firmSlug: this.user.firmSlug,
                matterSlug: this.matter.matterSlug,
                partySlug: this.plaintiff.partySlug,
                oldPlaintiff: oldPlaintiff
              });
              this.$store.dispatch("viewPlaintiff", editedPlaintiff);
            })
            .catch(e => console.log(e));
        })
        .catch(e => console.log(e));
      // .set({ plaintiffs: [{ plaintiff }] }, { merge: true })
      this.menu = false;
      this.dialog = false;
      this.allowSave = false;
      this.bizName = null;
      // this.fullName = null;

      // this.firstName = this.plaintiff.firstName;
      // this.lastName = this.plaintiff.lastName;
      // this.addressLine1 = this.plaintiff.addressLine1;
      // this.cityStateZip = this.plaintiff.cityStateZip;
      // this.phone = this.plaintiff.phone;
      // this.email = this.plaintiff.email;
      // this.attorney = this.plaintiff.attorney;
      // this.dateOfBirth = this.plaintiff.dateOfBirth;
      // this.type = this.plaintiff.type;

      // this.firstName = null;
      // this.lastName = null;
      // this.addressLine1 = null;
      // this.cityStateZip = null;
      // this.phone = null;
      // this.email = null;
      // this.attorney = null;
      // this.dateOfBirth = null;
      // this.type = null;

      // this.firstName = editedPlaintiff.firstName;
      // this.lastName = editedPlaintiff.lastName;
      // this.addressLine1 = editedPlaintiff.addressLine1;
      // this.cityStateZip = editedPlaintiff.cityStateZip;
      // this.phone = editedPlaintiff.phone;
      // this.email = editedPlaintiff.email;
      // this.attorney = editedPlaintiff.attorney;
      // this.dateOfBirth = editedPlaintiff.dateOfBirth;
      // this.type = editedPlaintiff.type;

      // this.$refs.form.reset();
    }

    //.firestore()
    // .collection("firms")
    // .doc(data.firmSlug)
    // .collection("matters")
    // .doc(data.matterSlug)
    // .collection("clients")
    // .doc(data.partySlug)
    // .set(client)
    // .then(() => {
    //   return console.log("successfully added client to client collection");
    // })
    // .catch(err => {
    //   return err;
    // });

    // const payload = {
    //   plaintiff: {
    //     fullName: this.fullName,
    //     addressLine1: this.addressLine1,
    //     cityStateZip: this.cityStateZip,
    //     phone: this.phone,
    //     email: this.email,
    //     attorney: this.attorney,
    //     dateOfBirth: this.dateOfBirth,
    //      type: this.type
    //   },
    //   firmSlug: this.user.firmSlug,
    //   matterSlug: this.matter.matterSlug
    // };
    // console.log(payload);
    // this.$store.dispatch("addPlaintiff", payload);
    // this.menu = false;
    // this.dialog = false;
    // this.allowSave = false;
    // this.fullName = this.matter.fullName;
    // this.addressLine1 = this.matter.addressLine1;
    // this.cityStateZip = this.matter.cityStateZip;
    // this.phone = this.phone;
    // this.email = this.email;
    // this.attorney = this.attorney;
    // this.dateOfBirth = this.dateOfBirth;
    // this.type = this.type;
  },
  logChange(event) {
    console.log("something changed");
    console.log(event);
    this.allowSave = true;
  },
  created() {
    console.log("plaintiff = ", this.plaintiff);
    this.$store.dispatch("viewPlaintiff", this.plaintiff);
  },
  beforeMount() {
    console.log("heloo beforemount", this.plaintiff);
  },
  mounted() {
    console.log("heloo mounted", this.plaintiff);
  },
  beforeUpdate() {
    console.log("heloo beforeUpdate", this.plaintiff);
  }
  // updated() {
  //   console.log("heloo updated", this.plaintiff);
  //   let p = this.$store.getters.plaintiff;
  //   console.log("this is the plaintiff in store", p);
  //   // this.firstName = this.plaintiff.firstName;
  //   // this.lastName = this.plaintiff.lastName;
  //   // this.addressLine1 = this.plaintiff.addressLine1;
  //   // this.cityStateZip = this.plaintiff.cityStateZip;
  //   // this.phone = this.plaintiff.phone;
  //   // this.email = this.plaintiff.email;
  //   // this.attorney = this.plaintiff.attorney;
  //   // this.dateOfBirth = this.plaintiff.dateOfBirth;
  //   // this.type = this.plaintiff.type;
  // },
};
// };
</script>

<style lang="scss" scoped></style>
